import { ChevronRight } from '@mui/icons-material';
import { Grid2 as Grid, styled, Typography } from '@mui/material';
import { DefaultLink } from '@shared/components/link';
import { I18nStore } from '@tools/i18n/store';
import { injectTSDI } from '@tools/tsdi';
import { observer } from 'mobx-react';
import * as React from 'react';
import ReactMarkdown from 'react-markdown';

import { LoginButton } from './components/button';
import TenantTextField from './components/tenant-text-field';

const RegisterText = styled(Typography)(({ theme }) => ({
    paddingRight: theme.spacing(1),
    display: 'inline'
}));

const Arrow = styled(ChevronRight)({
    verticalAlign: 'middle'
});

export const LoginContents = observer(() => {
    const { translate } = injectTSDI(I18nStore);
    return (
        <Grid container spacing={3} direction="column" alignItems="center">
            <Typography variant="h4">
                {translate('signup.login.header.text')}
            </Typography>
            <TenantTextField />
            <Grid>
                <Typography>
                    <ReactMarkdown
                        components={{ p: React.Fragment }}
                        linkTarget="_blank"
                    >
                        {translate('signup.login.helper.text')}
                    </ReactMarkdown>
                </Typography>
            </Grid>
            <Grid>
                <LoginButton />
            </Grid>
            <Grid>
                <RegisterText
                    variant="subtitle2"
                    align="left"
                    color="textSecondary"
                >
                    {`${translate('signup.back.to.register.text')} `}
                </RegisterText>
                <DefaultLink page="signup" keepQuery>
                    <Typography variant="subtitle1" component="span" noWrap>
                        {translate('signup.back.to.register.link')}
                        <Arrow />
                    </Typography>
                </DefaultLink>
            </Grid>
        </Grid>
    );
});
